<div
	cdkScrollable
	[id]="id"
	class="modal"
	tabindex="-1"
	role="dialog"
	data-keyboard="false"
	data-backdrop="static"
	>
	<ng-content></ng-content>
</div>